import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Chip,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  Slide,
  Stack, Tooltip
} from "@mui/material";
import { HasPermissions, getOrgType, getisEmp } from "../../../utils/Token";
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import axios from "../../../utils/fvAxios";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import "react-toastify/dist/ReactToastify.css";
import EditTraningMoodle from "./EditTraningMoodle";
import EmployeeCerdentials from "./EmployeeCerdentials";
import useFetch from "../../../utils/useFetch";
import fileDownload from "js-file-download";
import Mastercard from "../../../icons/Dot.svg"
import Mastercard1 from "../../../icons/Vector (10).png"
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { ToastContainer, toast } from "react-toastify";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { groupBy } from 'lodash';
import { useTranslation } from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import EmployeeCousre from "./EmployeeCousre";
import { displayName } from "react-quill";
import Avatar from "@mui/material/Avatar";
import EmpBlackIcon from "../../../icons/BlackList";
import EmpBlackedIcon from "../../../icons/BlackListed";
import InfoIcon from '@mui/icons-material/Info';
import BlacklistedNew from "../../../icons/BlackListedNew.svg";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#667085",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function EmployeeTrainingDetails({ row, refe, setResh, type, docclient, empdocument, EmpBlackPOP, BlackLInfo, ClientListInfo, DeTag }) {
  const params = new URLSearchParams(window.location.search);
  const vendorid = params.get("Vendor");
  const isbAck = params.get("back");
  const [CloseWindow, setCloseWindow] = React.useState('');
  const isEmployee = getisEmp()


  const DeleteEmployee = async () => {
    axios
      .post(
        "Employee/DeleteMoodleUserCourse?userId=" + Emp + "&courseId=" + EmpId,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseMessage == "Success") {
          handlePopClose();
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setResh(!refe)
        } else {
          toast.error(res?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const [openpop, setOpenpop] = React.useState(false);
  const [openpop1, setOpenpop1] = React.useState(false);
  const [EmpId, setEmpId] = React.useState();
  const [Emp, setEmp] = React.useState();
  const [EmpTraining, setEmpTraining] = React.useState();
  const [Trainging, settraining] = React.useState('');



  const { t } = useTranslation();
  const handleClickOpenpop = (user, id) => {
    setEmp(user)
    setEmpId(id)
    setOpenpop(true);
  };
  const [Emptrainingpop, setEmptrainingpop] = React.useState(false);
  const handleClickOpenpop1 = (user, id) => {

    axios
      .get("Employee/GetCourseURL?courseId=" + user?.courseid + "&isMoodleCourse=" + user?.isMoodleCourse + "&launch=" + user?.launch + "&scormId=" + user?.scormid + "&moodleUserId=" + id + "&renewalStatus=" + user?.renewalstatus,

      )
      .then((res) => {

        if (res?.data?.responseMessage == "Success") {
          settraining(res?.data?.data);



          // var myWindow = window.open(res?.data?.data, "myWindow", 'width=800,height=600');
          // var pollTimer = window.setInterval(function () {
          //   if (myWindow.closed !== false) {
          //     window.clearInterval(pollTimer);

          //     setResh(!refe)

          //   }
          // }, 200);

          if (res?.data?.data.startsWith("../Employee")) {
            // If res.data.data starts with "../Employee"
            // var myWindow = window.open("", "myWindow", 'width=800,height=600');


            // myWindow.document.write("<button onclick='proceedToAcko()'>Proceed to Acko</button>");


            // myWindow.proceedToAcko = function() {

            //   var ackoWindow = window.open(res?.data?.data, "ackoWindow", 'width=800,height=600');


            //   var ackoPollTimer = window.setInterval(function () {
            //     if (ackoWindow.closed !== false) {
            //       window.clearInterval(ackoPollTimer);

            //       setResh(!refe);
            //     }
            //   }, 1000); 
            // };
            var url = res?.data?.data;

            // Remove "../" from the beginning of the URL
            var cleanedUrl = url?.replace(/^(\.\.\/)+/, "");
            axios
              .get(cleanedUrl).then((r) => {
                if (r?.data?.responseMessage == "Success") {
                  setEmpTraining(r?.data?.data)
                }
                setEmptrainingpop(true)

              })


          } else {

            var myWindow = window.open(res?.data?.data, "myWindow", 'width=800,height=600');


            var pollTimer = window.setInterval(function () {
              if (myWindow.closed !== false) {
                window.clearInterval(pollTimer);

                setResh(!refe);
              }
            }, 1000);
          }

          setCloseWindow(myWindow)
          // if (myWindow && myWindow.closed) {
          //   debugger;
          //     console.log("The window is closed.");
          // } else {
          //     console.log("The window is still open.");
          // }

        } else {

          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });

  };

  const handlePopClose1 = () => {
    setOpenpop1(false);
  };
  const handlePopClose = () => {
    setOpenpop(false);
  };
  // const DeleteMoodleUserCourse = async (user, id) => {
  //   axios
  //     .post(
  //       "Employee/DeleteMoodleUserCourse?userId=" + user + "&courseId=" + id,
  //       {
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     )
  //     .then((res) => {
  //       if (res?.data?.responseMessage == "Success") {
  //         toast.success(res?.data?.data, {
  //           position: "top-right",
  //           autoClose: 4000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //         setResh(!refe)
  //       } else {
  //         toast.error(res?.data?.data, {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //       }

  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  const [spinner, setSpinner] = React.useState(false);
  const SpinnerClose = () => {
    setSpinner(false);
  };
  const [open1, setOpen1] = React.useState(false);
  const [users, setUser] = React.useState();
  const [courses, setCourse] = React.useState();
  const [moodles, setMoodle] = React.useState();
  const [CertificateDownload, setCertificateDownloade] = React.useState();
  const [clearCache, setclearcache] = React.useState(false);
  const handleClickOpen = (user, cousre, moodle) => {
    setUser(user);
    setCourse(cousre);
    setMoodle(moodle);
    setOpen1(true);
  };
  const handleClose = () => {
    setOpen1(false);
  };
  const [emailopen, seEmailtOpen1] = React.useState(false);

  const [emaildata, seEmailtdata] = React.useState(false);
  const handleClickEmail = (e) => {
    seEmailtdata(e);
    seEmailtOpen1(true);
  };
  const handleEmailClose1 = () => {
    seEmailtOpen1(false);
  };
  const handleEmailClose2 = () => {
    setEmptrainingpop(false);
    setclearcache(!clearCache)

  }

  const handleRenew = async (row, r) => {
    // console.log(row, r);
    // const checkedValues = Object.values(checkedItems1).filter(item => item.isChecked);
    setSpinner(true);
    const userRoles = [{
      "courseId": r?.courseid + "",
      "fvEmpId": "00000000-0000-0000-0000-000000000000",
      "courseName": r?.coursename,
      "moodleEmpId": row?.userid + "",
      "employeeName": row?.lastname + " " + row?.firstname,
      "empStatus": true,
      "clientId": r?.clientid,
      "courseStatus": true,
      "courseFee": r?.coursefee,
      "clientName": r?.clientname,
      "expiryMonth": "",
      "isProRateRequired": "false",
      "IsRequestFromRenewButton": "true"
    }];

    const obj = {
      "vendorId": row?.vendorid,
      "empCourses": userRoles,
      "payType": 1

    };

    const res = await axios.post("Employee/AddEmployeesToCart", obj)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          axios.post("Employee/GetTrainingPaymentURLs?VendorId=" + row?.vendorid,)
            .then((res) => {
              if (res?.data?.responseCode == 100) {
                toast.success(res?.data?.responseMessage, {
                  position: "top-right",
                  autoClose: 4000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });

                setResh(!refe)
              } else {
                toast.error(res?.data?.data, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });

              }
            }).catch(err => {
              console.log(err);
            }).finally(() => {
              // setIsLoading(false);
              // setSpinner(false);
            })


        } else {
          toast.error(
            <div>
              <p>Couldn't renew the training, as one of the following conditions was not satisfied:</p>
              <p>1. Prequalification has expired.</p>
              <p>2. Location specific to the course was not selected.</p>
              <p>3. Annual training fee (if applicable) was not paid.</p>
              <p>4. The course is not eligible for renewal.</p>
            </div>,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              style: { width: '450px', right: '130px' }
            }
          );

        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {


        setTimeout(() => {
          setSpinner(false);
        }, 3000);
      })
  }

  const handleDownload = (id, ids, num) => {

    setSpinner(true);
    const exp = num == '0' ? ids?.expiringdatetodisplay : ids?.expiringdate;
    const last = num == '0' ? ids?.lastwatchedtodisplay : ids?.lastwatched;
    axios
      .get(
        "Employee/GenerateTrainingCompletionCertificateForMoodleCourse?userId=" +
        id +
        "&courseId=" +
        ids?.courseid +
        "&courseName=" +
        ids?.coursename +
        "&lastWatched=" +
        last +
        "&previouslyPassedOn=" +
        ids?.previouslypassed +
        "&quizStatus=" +
        ids?.quizstatus +
        "&renewalstatus=" +
        ids?.isrenewal +
        "&expiringdate=" +
        exp,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        //fileDownload(res.data, "Training Certificate.pdf");

        const file = new Blob([res?.data], { type: "application/pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

        setSpinner(false);
      });
  };
  const handleDownload1 = (Trainid, fvuser, lastwatch, courseid, moodleUserId) => {
    setSpinner(true);
    axios
      .get(
        "Documents/DownloadTrainingDoc?fileName=" +
        Trainid +
        "&empId=" +
        fvuser +
        "&empDate=" +
        lastwatch + "&courseId=" + courseid + "&moodleUserId=" + moodleUserId,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        // fileDownload(res.data, "Download Document.pdf");


        const file = new Blob([res?.data], { type: "application/pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

        // const blob = new Blob([res.data], { type: res.headers['content-type'] });
        // const blobUrl = URL.createObjectURL(blob);
        // window.open(blobUrl, '_blank');
        // URL.revokeObjectURL(blobUrl);
        setSpinner(false);
      });
  };

  const GenerateQuizWaiverFormCertificate = (userId, isMoodleCourse, courseid, lastwatched, id) => {
    setSpinner(true);

    axios
      .get(
        isMoodleCourse
          ? "Employee/GenerateQuizWaiverFormCertificateForMoodleCourse?userId=" +
          userId +
          "&courseId=" +
          courseid +
          "&submittedDate=" +
          lastwatched +
          "&quizdetailsId=" +
          id
          : "Employee/GenerateQuizWaiverFormCertificate?sysUserOrgQuizId=" +
          id,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        // fileDownload(res.data, "Waiver Form.pdf");

        const file = new Blob([res?.data], { type: "application/pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');


        setSpinner(false);
      });
  };
  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  const groupedTrainings = groupBy(row?.tranings, 'clientname');
  const [isDownloading, setIsDownloading] = useState(false);
  const DownloadTraingGuide = (fileName, client) => {
    setIsDownloading(true);

    axios.get("Documents/DownloadDoc?fileName=" + decodeURIComponent(fileName) + "&ConfigPath=Employee Guide&clientId=" + client?.clientID, { responseType: "blob" })

      .then((res) => {
        if (res?.data?.type == "application/json") {
          toast.error("File not found", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setIsDownloading(false);

          const file = new Blob([res?.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

          // const blob = new Blob([res.data], { type: res.headers['content-type'] });
          // const blobUrl = URL.createObjectURL(blob);
          // window.open(blobUrl, '_blank');
          // URL.revokeObjectURL(blobUrl);
        }
      })
  }

  const [isDownloading1, setIsDownloading1] = useState(false);
  const DownloadTraingGuide1 = (r) => {
    setIsDownloading1(true);

    axios.get("Employee/DownloadEmpDoc?idAsFileName=" + r?.documentId + "&userEnteredFilename=" + r?.docName + "&vendorId=" + r?.vendorId, { responseType: "blob" })
      .then((res) => {
        if (res?.data?.type == "application/json") {
          toast.error("File not found", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setIsDownloading1(false);

          // const blob = new Blob([res.data], { type: res.headers['content-type'] });
          // const blobUrl = URL.createObjectURL(blob);
          // window.open(blobUrl, '_blank');
          // URL.revokeObjectURL(blobUrl);

          const file = new Blob([res?.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

        }
      }).finally(() => {
        setIsDownloading1(false);
      })
  }
  function stringToDate(_date, _format, _delimiter) {
    var formatLowerCase = _format?.toLowerCase();
    var formatItems = formatLowerCase?.split(_delimiter);
    var dateItems = _date?.split(_delimiter);
    var monthIndex = formatItems?.indexOf("mm");
    var dayIndex = formatItems?.indexOf("dd");
    var yearIndex = formatItems?.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate1 = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate1;
  }
  function parseDateString(dateString) {
    var parts = dateString?.split('/');
    var date = new Date(parts[2], parts[1] - 1, parts[0]);
    return date;
  }

  // var date1 = parseDateString("09/08/2022");

  // var formattedDate1 = ("0" + date1.getDate()).slice(-2) + "/" + ("0" + (date1.getMonth() + 1)).slice(-2) + "/" + date1.getFullYear();

  // console.log(formattedDate1)
  const sortedClientNames = Object.keys(groupedTrainings).sort()
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner || isDownloading1 || isDownloading}
        onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <ToastContainer /> */}
      <Dialog
        fullScreen
        open={emailopen}
        onClose={handleEmailClose1}
        TransitionComponent={Transition}
      >
        <EmployeeCerdentials
          handleClose1={handleEmailClose1}
          emailData={emaildata}
        />
      </Dialog>

      {/* questionnairre  */}
      <Dialog
        fullScreen
        open={Emptrainingpop}
        onClose={handleEmailClose2}

        keepMounted

        aria-describedby="alert-dialog-slide-description"
      >
        <EmployeeCousre data={EmpTraining} handleClose1={handleEmailClose2} clearCaches={clearCache} refes={refe} setRes={setResh} />
      </Dialog>



      <Dialog
        open={openpop}
        keepMounted
        onClose={handlePopClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          {" "}
          {"Are you sure you want to delete the employee training?"}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-slide-description">
            {t('VendorDetails.label9')}
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePopClose}>{"Cancel"}</Button>
          <Button onClick={DeleteEmployee}>{t("VendorDetails.label8")}</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openpop1}
        keepMounted
        onClose={handlePopClose1}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>

        </DialogTitle>
        <DialogContent>

        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handlePopClose}>{"Cancel"}</Button>
          <Button onClick={DeleteEmployee}>{t("VendorDetails.label8")}</Button> */}
        </DialogActions>
      </Dialog>
      <Dialog
        open={open1}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <EditTraningMoodle
          REFRESH={refe}
          SetREFRESH={setResh}
          close={handleClose}
          users={users}
          courses={courses}
          moodles={moodles}
        />
      </Dialog>
      <Box sx={{ margin: 1, paddingLeft: "60px" }}>
        {/* Employee Documents */}
        <div>
          <h5 style={{ color: "#667085", fontWeight: "600", padding: "10px" }} hidden={row?.empDocs?.length == 0 || type === "Client"} >
            Employee Documents
          </h5>
          {/* <span  style={{ color: "#2A93DB", fontSize: "14px", cursor: "pointer" }} onClick={DownloadTraingGuide}>   <InsertDriveFileOutlinedIcon /> Employer Guide-Adding employees.pdf</span> */}

          {row?.empDocs?.map((r) => (

            <div key={r?.userId} style={{ fontSize: "17px", color: "#61affe", marginBottom: r.userId ? "10px" : "", cursor: "pointer" }} onClick={() => DownloadTraingGuide1(r)}>
              <InsertDriveFileOutlinedIcon /> {r.docName}
            </div>
          ))}
{/* 
          <div style={{ marginLeft: "10px", color: "#EE3F3F", fontSize: "17px", fontWeight: "bold" }}>
            <strong>NOTICE:</strong>
            <ul style={{ marginTop: "8px", paddingLeft: "25px" }}>
              <li>
                If you receive the “OOPS” error message, disable the popup blocker on your device and/or browser.
              </li>
              <li>
                After completing the orientation, allow quiz results to load completely and click "Exit Course" in the top right.
              </li>
              <li>
                If you completed the course and it still shows “In Process,” open it again to ensure that all content is marked as complete in the left-hand menu.
              </li>
              <li>
                Make sure the last course's quiz results have loaded.
              </li>
            </ul>
          </div> */}

          <p style={{ color: "red", fontWeight: "bold" }} hidden={isEmployee != "true"}> Please Note: After completing the orientation, data will load in less than 120 seconds on this page. Thank you for your patience.
          </p>

        </div>
        {sortedClientNames?.map(clientName => (
          <div key={clientName}>
            <Stack direction="row" spacing={2}>
              <span style={{ padding: "10px" }}>
                <h4 style={{ color: "#667085", fontWeight: "600", padding: "10px" }}>
                  {/* {clientName}{row?.vendorname} */}
                  {isbAck != "true" && getOrgType() == "Client" ? row?.vendorname : clientName}
                </h4>
              </span>{" "}
              <span style={{ padding: "10px", marginTop: "10px" }}>
                {" "}
                <Chip
                  sx={{ color: "#344054", fontWeight: "bold" }}
                  label={
                    <span>
                      {Array?.from(new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus)))
                        ?.length >= 2 ? (
                        <div>
                          <svg viewBox="0 0 24 24" width="20" height="20">
                            <circle cx="12" cy="12" r="10" fill="white" />
                            <path
                              d="M12 12 L12 2 A10 10 0 0 1 22 12 Z"
                              fill="#ED8A17"
                            />
                            <path
                              d="M12 12 L22 12 A10 10 0 0 1 12 22 Z"
                              fill="#12B76A"
                            />
                            <path
                              d="M12 12 L12 22 A10 10 0 0 1 2 12 Z"
                              fill="#5925DC"
                            />
                            <path
                              d="M12 12 L2 12 A10 10 0 0 1 12 2 Z"
                              fill="#EE3F3F"
                            />
                          </svg>
                          <span style={{ marginLeft: "2px" }}>Multiple</span>
                        </div>
                      ) : (
                        <span>
                          <FiberManualRecordIcon
                            hidden={
                              Array.from(
                                new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                              ) != "Passed"
                            }
                            sx={{ color: "#12B76A" }}
                          />{" "}
                          <FiberManualRecordIcon
                            hidden={
                              Array.from(
                                new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                              ) != "Not Attended"
                            }
                            sx={{ color: "#ED8A17" }}
                          />{" "}
                          <FiberManualRecordIcon
                            hidden={
                              Array.from(
                                new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                              ) != "Failed"
                            }
                            sx={{ color: "#EE3F3F" }}
                          />{" "}
                          <FiberManualRecordIcon
                            hidden={
                              Array.from(
                                new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                              ) != "InProcess"
                            }
                            sx={{ color: "#5925DC" }}
                          />{" "}
                          <img
                            src={Mastercard}
                            alt="Expired"
                            style={{ width: "20px", marginRight: "5px" }}
                            hidden={
                              Array.from(
                                new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                              ) != "Expired"
                            }
                          />{" "}
                          {Array.from(
                            new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                          )}{" "}
                        </span>
                      )}{" "}
                    </span>
                  }
                />
              </span>
              <div hidden={DeTag == 1 || getOrgType() == "Vendor" || getOrgType() == "Client"}>
                <div style={{ padding: "10px", float: "right", marginTop: "8px" }} hidden={BlackLInfo?.find((r) => r?.moodleEmpId == row?.userid)?.isGloballyBlackListed == true}>
                  {(() => {
                    const emp = BlackLInfo?.find((r) => r?.moodleEmpId == row?.userid);
                    const clientId = ClientListInfo?.find((r) => r?.text == clientName)?.value;

                    // Case: Globally blacklisted → hide everything
                    if (emp?.isGloballyBlackListed) return null;

                    // Case: No employee found → show EmpBlackIcon only
                    if (!emp) {
                      return (
                        <Box
                          sx={{ position: "relative", width: 30, height: 30, cursor: "pointer" }}
                          onClick={() => EmpBlackPOP(3, row?.fvuserid, row?.userid, clientName)}
                        >
                          <EmpBlackIcon />
                        </Box>
                      );
                    }

                    // Filter site names for this clientId
                    const siteNames = emp.blacklistedLocationsInfo
                      ?.filter((loc) => loc?.clientId == clientId)
                      ?.map((r) => r?.siteName)
                      ?.join(", ");
                    const TillDate = emp?.blacklistedLocationsInfo
                      ?.find(item => item.clientId == clientId)?.blackListedTill

                    // Case: Employee blacklisted but no matching clientId → show EmpBlackIcon
                    if (!siteNames) {
                      return (
                        <Box
                          sx={{ position: "relative", width: 30, height: 30, cursor: "pointer" }}
                          onClick={() => EmpBlackPOP(3, row?.fvuserid, row?.userid, clientName)}
                        >
                          <EmpBlackIcon />
                        </Box>
                      );
                    }

                    // Case: Employee blacklisted with matching clientId → show EmpBlackedIcon + Tooltip
                    return (
                      <div style={{ display: "flex", alignItems: "center", float: "right", cursor: "pointer" }}>
                        <Box
                          sx={{ position: "relative", width: 30, height: 30, cursor: "pointer", mr: 1 }}
                          onClick={() => EmpBlackPOP(4, row?.fvuserid, row?.userid, clientName)}
                        >
                          <EmpBlackedIcon />
                        </Box>

                        <Tooltip title={siteNames} placement="top" arrow>
                          {/* <InfoIcon sx={{ fontSize: 35, color: "#b9baba", cursor: "pointer" }} /> */}
                          <img src={BlacklistedNew} alt="Blacklisted" width="30" height="30" />
                        </Tooltip>

                        <Box sx={{ position: "relative", mr: 3 }}>
                          <span className="mx-2" style={{ color: "#3E4A62", fontSize: "18px" }}>{GetfVDateFormate(TillDate)}</span>
                        </Box>
                      </div>
                    );
                  })()}

                </div>
              </div>
            </Stack>
            <br />
            <div>
              {docclient?.filter(client => {
                const clientCodes = groupedTrainings[clientName]?.map(course => course?.clientcode);
                return clientCodes?.includes(client?.singleClientCode) && client?.clientFileNames?.length > 0;
              })?.map(client => (
                client?.clientFileNames?.map((fileName) => (
                  <div key={fileName} style={{ fontSize: "17px", color: "#61affe", marginBottom: fileName ? "10px" : "", cursor: "pointer" }} onClick={() => DownloadTraingGuide(fileName, client)}>
                    <InsertDriveFileOutlinedIcon /> {fileName}
                  </div>
                ))
              ))}
            </div>

            <Table aria-label="purchases">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="left">Course Name</StyledTableCell>
                  <StyledTableCell align="left">Status</StyledTableCell>
                  <StyledTableCell align="left" >Renew</StyledTableCell>
                  <StyledTableCell align="left">Last Watched</StyledTableCell>
                  <StyledTableCell align="left">Start Date</StyledTableCell>
                  <StyledTableCell align="left">Expiration Date</StyledTableCell>
                  <StyledTableCell align="left">Previously Passed</StyledTableCell>
                  <StyledTableCell align="left">Is it a renewal</StyledTableCell>
                  <StyledTableCell align="left" hidden={isEmployee === "true"}>&nbsp;</StyledTableCell>
                  <StyledTableCell align="left" hidden={type == "Vendor"}>&nbsp;</StyledTableCell>
                  <StyledTableCell align="left" hidden={type == "Vendor"}>&nbsp;</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {groupedTrainings[clientName]?.sort((a, b) => (a?.coursename > b?.coursename) ? 1 : -1)?.map((r, index) => (
                  <React.Fragment key={index} >

                    <TableRow hidden={r?.coursename == null}>
                      <TableCell component="th" scope="row" >

                        {isEmployee === "true" ? (r?.hasCourseAccess == true ? <div onClick={() => handleClickOpenpop1(r, row?.userid)} style={{ color: "#2A93DB", cursor: "pointer" }}> <PlayArrowOutlinedIcon /> {r?.coursename}</div> : r?.coursename) : <div> {r?.coursename}</div>}
                      </TableCell>

                      <TableCell align={r?.quizstatus ? "left" : "center"}>
                        <Chip
                          sx={{ color: "#344054", fontWeight: "bold" }}
                          label={
                            <span>
                              <span>
                                <FiberManualRecordIcon
                                  hidden={r?.quizstatus != "Passed"}
                                  sx={{ color: "#12B76A" }}
                                />{" "}
                                <FiberManualRecordIcon
                                  hidden={r?.quizstatus != "Not Attended"}
                                  sx={{ color: "#ED8A17" }}
                                />{" "}
                                <FiberManualRecordIcon
                                  hidden={r?.quizstatus != "Failed"}
                                  sx={{ color: "#EE3F3F" }}
                                />{" "}
                                <FiberManualRecordIcon
                                  hidden={r?.quizstatus != "InProcess"}
                                  sx={{ color: "#5925DC" }}
                                />{" "}
                                <img
                                  src={Mastercard}
                                  alt="Expired"
                                  style={{ width: "20px", marginRight: "5px" }}
                                  hidden={r?.quizstatus != "Expired"}
                                />{" "}
                                {r?.renewalstatustodisplay != "" ? r?.renewalstatustodisplay : r?.quizstatus}
                              </span>
                            </span>
                          }
                        />
                      </TableCell>
                      {/* hidden={  getOrgType() == "Client"&&r?.coursefee!="0" && r.expiringdate==""&&r.expiringdate < new Date()} */}
                      <TableCell

                        align={r?.lastwatchedtodisplay ? "center" : "center"}
                        style={{ width: "15%" }}
                      >
                        <Tooltip title="Renew" placement="top" arrow>
                          <Button
                            variant="outlined"
                            color="error"
                            style={{
                              display: (getOrgType() !== "Client" &&
                                r?.coursefee === "0" &&
                                r?.expiringdate &&
                                (new Date(r?.expiringdate) < new Date(formattedDate) ||
                                  (new Date(r?.expiringdate) - new Date(formattedDate)) / (1000 * 60 * 60 * 24) <= 30))
                                ? "block"
                                : "none"
                            }}
                            onClick={() => {
                              handleRenew(row, r);
                            }}
                          >
                            <img src={Mastercard1} alt="Mastercard" style={{ width: "16px" }} />  <span style={{ fontSize: "10px" }}>Renew</span>
                          </Button>
                        </Tooltip>
                      </TableCell>

                      <TableCell align={r?.lastwatchedtodisplay ? "center" : "center"}>
                        {r?.lastwatchedtodisplay ? GetfVDateFormate(r?.lastwatchedtodisplay) : "-"}

                      </TableCell>
                      <TableCell align={r?.startDate ? "center" : "center"}>
                        {r?.startDate ? GetfVDateFormate(r?.startDate) : "-"}
                      </TableCell>
                      <TableCell align={r?.expiringdatetodisplay ? "center" : "center"}>
                        {r?.expiringdatetodisplay ? GetfVDateFormate(r?.expiringdatetodisplay) : "-"}
                      </TableCell>
                      <TableCell align={r?.previouslypassed ? "left" : "center"}>
                        {r?.previouslypassed ? (r?.previouslypassedstatus + "-" + r?.previouslypassed) : ""}
                      </TableCell>
                      <TableCell align={"center"}>
                        {/* {r.isrenewal ? r.isrenewal : "-"} */}
                        {r?.isrenewal == true ? "Yes" : "No"}
                      </TableCell>

                      <TableCell style={{ width: "20px" }} hidden={isEmployee === "true" || type === "Client"} >
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          // onClick={handleClickEmail}
                          // onClick={()=>handleClickEmail(row?.fvuserid)}
                          onClick={() => {
                            handleClickEmail(row?.fvuserid);
                          }}

                        >
                          <Tooltip
                            title="Share User Credentials"
                            placement="top"
                            arrow
                          >
                            <ShareRoundedIcon sx={{ color: "#98A2B3" }} />
                          </Tooltip>
                        </IconButton>
                      </TableCell>
                      <TableCell style={{ width: "20px" }} hidden={isEmployee === "true" || type === "Vendor"}>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => {
                            handleClickOpen(
                              row?.userid,
                              r?.courseid,
                              r?.isMoodleCourse
                            );
                          }}

                        >
                          <Tooltip
                            title="Onsite Training"
                            placement="top"
                            arrow
                          >
                            <EditRoundedIcon sx={{ color: "#98A2B3" }} />
                          </Tooltip>
                        </IconButton>
                      </TableCell>
                      <TableCell style={{ width: "20px" }} hidden={type != "Admin"}>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          // onClick={() => {
                          //   DeleteMoodleUserCourse(row.userid, r.courseid);
                          // }}
                          onClick={() => handleClickOpenpop(row?.userid, r?.courseid)}
                        >
                          <Tooltip title="Delete" placement="top" arrow hidden={type == "Vendor"}>
                            <DeleteOutlineIcon sx={{ color: "#98A2B3" }} />
                          </Tooltip>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableCell colSpan={3} style={{ border: 'none' }}>
                      <Box
                        sx={{

                          padding: "10px",

                        }}
                      >
                        <div

                          style={{ display: ((r?.hasTrainingCertificate === true || r?.previousQuizNotExpired === true) && r?.clientHasTrainingCertificate === true ? "" : "none") }}
                        >
                          <Button
                            onClick={() =>
                              handleDownload(
                                row?.userid,
                                r, "0"

                              )
                            }
                            style={{
                              color: "#2A93DB",
                              cursor: "pointer",

                            }}
                          >
                            <InsertDriveFileOutlinedIcon
                              sx={{
                                marginRight: "5px",
                                color: "#2A93DB",
                                cursor: "pointer",
                              }}
                            />
                            Training Certificate
                          </Button>

                          {r?.hasRenewalTrainingCertificate == true &&
                            r?.oldquizexpiringdate != null &&
                            (new Date(r?.oldquizexpiringdate) > new Date(formattedDate))
                            ? (
                              <Button
                                onClick={() =>
                                  handleDownload(
                                    row?.userid,
                                    r, "1"

                                  )
                                }
                                style={{
                                  color: "#2A93DB",
                                  cursor: "pointer",

                                }}
                              >
                                <InsertDriveFileOutlinedIcon
                                  sx={{
                                    marginRight: "5px",
                                    color: "#2A93DB",
                                    cursor: "pointer",
                                  }}
                                />
                                Renewal Training Certificate

                              </Button>


                            ) : (
                              <></>
                            )}
                        </div>
                        {((r?.HasTrainingCertificate === true || r?.PreviousQuizNotExpired === true) &&
                          r?.ClientHasTrainingCertificate === true) && (
                            <tr>

                              <td colSpan={3}>
                                <a
                                  onClick={() =>
                                    handleDownload(
                                      row?.userid,
                                      r

                                    )
                                  }
                                  href="javascript:void(0)"
                                >
                                  <i
                                    className="fa fa-file-pdf-o"
                                    style={{
                                      fontSize: 'x-large',
                                      paddingRight: '10px',
                                      color: 'red',
                                    }}
                                  ></i>
                                  Training Certificate
                                </a>
                              </td>
                              {r?.HasRenewalTrainingCertificate === true &&
                                r?.PreviousQuizNotExpired != null &&
                                (r?.PreviousQuizNotExpired) > formattedDate ? (
                                <td colSpan={4}>
                                  <a
                                    onClick={() =>
                                      handleDownload(
                                        row?.userid,
                                        r

                                      )
                                    }
                                    href="javascript:void(0)"
                                  >
                                    <i
                                      className="fa fa-file-pdf-o"
                                      style={{
                                        fontSize: 'x-large',
                                        paddingRight: '10px',
                                        color: 'red',
                                      }}
                                    ></i>
                                    Renewal Training Certificate
                                  </a>
                                </td>
                              ) : (
                                <td colSpan={4}></td>
                              )}
                            </tr>
                          )}



                        {r?.waiverFormConfigured === true && r?.quizstatus === "Passed" && (
                          r?.quizWaiverFormDocuments?.map((doc, index) => (
                            <Button
                              key={index}
                              onClick={() =>
                                GenerateQuizWaiverFormCertificate(
                                  row?.fvuserid,
                                  r?.isMoodleCourse,
                                  r?.courseid,
                                  r?.lastwatched,
                                  doc?.id
                                )
                              }
                              sx={{ color: "#2A93DB" }}
                            >
                              <InsertDriveFileOutlinedIcon
                                sx={{ marginRight: "5px", color: "#2A93DB" }}
                              />
                              {doc?.displayName ? doc?.displayName : "Additional Form"}
                            </Button>
                          ))
                        )}


                        {/* 
                    {r?.waiverFormConfigured === true && r?.quizstatus === "Passed" && (
                      r?.quizWaiverFormDocuments.map((doc, index) => (
                        <Button
                          key={index}
                          onClick={() =>
                            GenerateQuizWaiverFormCertificate(
                              r.sysUserOrgQuizId,
                              r.isMoodleCourse,
                              r.courseId,
                              r.lastWatchedOrSubmitted,
                              doc.id
                            )
                          }
                          sx={{ color: "#2A93DB" }}
                        >
                          <InsertDriveFileOutlinedIcon
                            sx={{ marginRight: "5px", color: "#2A93DB" }}
                          />
                          {doc.displayName ? doc.displayName : "Additional Form"}
                        </Button>
                      ))
                    )} */}

                        {/* {(r.PreviousQuizNotExpired === true || r.quizstatus === "Passed") &&
                      r.waiverFormConfigured === true &&
                      r?.quizWaiverFormDocuments.map((doc, index) => (
                        <Button
                          key={index}
                          onClick={() =>
                            GenerateQuizWaiverFormCertificate(
                              r.clientcode,
                              true,
                              r.courseId,
                              row.fvuserid,
                              r.lastwatched,
                              doc.id
                            )
                          }
                          sx={{ color: "#2A93DB" }}
                        >
                          <InsertDriveFileOutlinedIcon
                            sx={{ marginRight: "5px", color: "#2A93DB" }}
                          />
                          {doc.displayName ? doc.displayName : "Additional Form"}
                        </Button>
                      ))} */}

                        {(
                          (r?.trainingDocumentConfigured === true &&
                            r?.quizstatus === "Passed") ||
                          (r?.previousQuizNotExpired && r?.trainingDocumentId !== "")
                        ) &&
                          r?.quizDocuments?.map((quizDoc, quizIndex) => (
                            <Button
                              key={quizIndex}
                              onClick={() =>
                                handleDownload1(
                                  quizDoc?.documentId,
                                  row?.fvuserid,
                                  r?.lastwatched,
                                  r?.courseid,
                                  row?.userid

                                )
                              }
                              sx={{ color: "#2A93DB" }}
                            >
                              <InsertDriveFileOutlinedIcon
                                sx={{ marginRight: "5px", color: "#2A93DB" }}
                              />
                              {quizDoc?.displayName
                                ? quizDoc?.displayName
                                : clientName}
                            </Button>
                          ))}
                      </Box>
                    </TableCell>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>

          </div>
        ))}
      </Box >
    </>
  );
}
